import { render, staticRenderFns } from "./CopyMultiOsType.vue?vue&type=template&id=211c1e0a"
import script from "./CopyMultiOsType.vue?vue&type=script&lang=js"
export * from "./CopyMultiOsType.vue?vue&type=script&lang=js"
import style0 from "./CopyMultiOsType.vue?vue&type=style&index=0&id=211c1e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports